import { Injectable } from '@angular/core';
import { Region } from '../interfaces/region';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegionCrudService {

 
  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/regions/' ;
  }

  // Create Region
  add(record: Region) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Region Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Regions List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Region Object
  update(record: Region) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Region>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Region Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
